module.exports = __webpack_public_path__ + "img/Proliferation-BLCA_GSE171351.fef3d8a7.png";